<template>
  <div v-if="useConfirmModal">
    <div v-if="icon" class="cursor-pointer">
      <font-awesome-icon :icon="icon" @click.prevent="showConfirmModal=true"/>
    </div>
    <div v-else>
      <button
        type="button"
        :class="[backgroundColor, border, textSize, textColor, hoverClass]"
        class="flex border-gray-300 text-center justify-center
      font-bold min-w-5 min-h-5 circle ml-0.5"
        @click.prevent="showConfirmModal=true"
      >{{buttonChar}}
      </button>
    </div>

    <ConfirmationModal
      :is-visible="showConfirmModal"
      :message="confirmModalMessage"
      @confirm="emit_message"
      @cancel="showConfirmModal = false"
    />
  </div>
  <div v-else>
    <div
      type="button"
      :class="[backgroundColor, border, textSize, textColor, hoverClass]"
      class="cursor-pointer flex items-center text-center justify-center
    font-bold min-w-5 min-h-5 circle ml-1"
      @click.prevent="emit_message"
    >{{buttonChar}}
    </div>
  </div>

</template>

<script>
import ConfirmationModal from '@/components/widgetcomponents/ConfirmationModal.vue'

export default {
  components: {ConfirmationModal},
  props: {
    icon: {
      type: Object,
      default: null
    },
    emission: {
      type: String,
      default: 'close'
    },
    useConfirmModal:{
      type: Boolean,
      default:false
    },
    confirmModalMessage:{
      type:String,
      default:'Are you sure you want to delete this object'
    },
    buttonChar:{
      type:String,
      default:'x'
    },
    border:{
      type:String,
      default:'border'
    },
    backgroundColor:{
      type:String,
      default:'bg-gray-200'
    },
    textSize:{
      type:String,
      default:'text-xs'
    },
    textColor:{
      type:String,
      default:'text-gray-400'
    },
    hoverClass: {
      type: String,
      default: 'hover:text-orange-500'
    }
  },
  data(){
    return {
      showConfirmModal:false
    }
  },
  methods:{
    emit_message(){
      this.$emit(this.emission)
      this.showConfirmModal=false
    },
  },
}
</script>

<style scoped>
.circle {
  width: 15px; /* Size of the circle */
  height: 15px; /* Size of the circle */
  border-radius: 50%; /* Makes it round */
}
</style>